<template>
  <div class="start">
    <div class="center-box">
      <div class="title">VoD QA Dashboard</div>
      <img class="logo" src='http://images.mixd.tv/images/logo.png' />

      <div class="input-box">
        <div class="form-entry">
          Username:
          <input v-model="form.name" type="text" class="form-control" >
        </div>
        <div class="form-entry">
          Password:
          <input v-model="form.pass" type="password" class="form-control" >
        </div>
      </div>
      <div class="button-box">
        <button class="login-button" @click="login()">Login</button>
      </div>
  </div>
  </div>
</template>

<script>
import router from '../router/index'

export default {
  name: 'loading',
  data () {
    return {
      form: {
        name: '',
        pass: ''
      }
    }
  },
  methods: {
    login: function () {
      if ((this.form.name === 'burda' && this.form.pass === 'demo-pass') ||
          (this.form.name === 'gold' && this.form.pass === 'demo-pass') ||
          (this.form.name === 'couchfunk' && this.form.pass === 'gwLuD1l&@SrMp') ||
          (this.form.name === 'isnottv' && this.form.pass === 'DcB;p8)k0b') ||
          (this.form.name === 'tvheute' && this.form.pass === 'demo-pass')) {
        if (router.currentRoute.path === '/loading') {
          router.replace('/locationList')
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.start {
  background-image: url('http://freenettv-dashboard.mixd.tv/squairy_dark.png');
  height: 100vh;
}
.center-box {
  background-color: rgba(255,255,255,0.1);
  border-radius: 5px;
  top: calc(50vh - 175px);
  left: calc(50vw - 180px);
  position: relative;
  padding: 5px;
  width: 360px;
  height: 250px;
}
.title {
  top: 5px;
  margin-left: -5px;
  width: 360px;
  text-align: center;
  color: rgba(255,255,255,0.7);
  background-color: rgba(0,0,0,0.5);
}
.logo {
  padding: 12px;
}
.input-box {
  display: flex;
  margin-bottom: 0px;
}
.form-entry {
  width: 170px;
  margin-bottom: 5px;
  height: 72px;
  border-radius: 3px;
  margin-left: auto;
  margin-right: auto;
  color: rgba(255,255,255,0.7);
  background-color: rgba(0,0,0,0.5);
}
.form-control {
  padding: 3px;
  margin: 8px;
  width: calc(100% - 16px);
}
.button-box {
  display: flex;
  width: calc(100% - 8px);
  margin: 8px;
  margin-top: 0px;
}
.login-button {
  width: calc(100% - 8px);
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/LoadingScreen.vue